import { StarIcon } from "icons";
import React from "react";
import { Heading, Text } from "ui-components";

interface IPlatinumBoxProps {
  isUserReachVisible?: boolean;
  isOrganizationProfileVisible?: boolean;
}

export function PlatinumBox({
  isUserReachVisible = false,
  isOrganizationProfileVisible = false,
}: IPlatinumBoxProps): JSX.Element {
  const starIcons = (
    <div className="flex gap-x-2.5 justify-center">
      {Array.from({ length: 5 }, (_, index) => (
        <StarIcon key={index} className="w-4 h-4 text-white" />
      ))}
    </div>
  );

  return (
    <div
      className={`${
        isOrganizationProfileVisible ? "w-full md:w-full" : "w-1/2 md:w-1/5"
      } p-[7px]`}
    >
      <div
        className={`w-full flex flex-col bg-[#3B3B3B] pt-5 ${
          isUserReachVisible ? "pb-5" : "pb-12"
        } px-4 items-center gap-y-3 ${
          isOrganizationProfileVisible ? "rounded-large" : "rounded-lg"
        }`}
      >
        {!isOrganizationProfileVisible && starIcons}
        <Heading className="text-white" variant="h3">
          PLATINUM
        </Heading>
        {isOrganizationProfileVisible && starIcons}
        {isUserReachVisible && (
          <Text className="text-white text-center">20 MILLION REACH</Text>
        )}
      </div>
    </div>
  );
}
